let Locale = {
  format: 'YYYY-MM-DD',
  separator: ' 至 ',
  applyLabel: '确定',
  cancelLabel: '取消',
  fromLabel: '从',
  toLabel: '到',
  customRangeLabel: 'Custom',
  weekLabel: 'W',
  daysOfWeek: [
    '日',
    '一',
    '二',
    '三',
    '四',
    '五',
    '六'
  ],
  monthNames: [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月'
  ],
  firstDay: 0
}
function isValidDate(date) {
  if(typeof date=='string') date = new Date(date)
  return date instanceof Date && !isNaN(date.getTime())
}
function dateTimePickerInit() {
  $('.date-range-picker').each(function () {
    $(this).parent().addClass('date-range-picker-wrapper')
    let isClear = $(this).attr('clear');
    if(isClear!='false'){
      $(this).after('<span class="date-clear">×</span>')
    }
    const elementBtnClear = $(this).siblings('.date-clear')
    var data = $(this).data()

    let locale = {...Locale}
    if(data.format){
      locale.format = data.format
    } else if(data.timePicker){
      locale.format = 'YYYY-MM-DD hh:mm:ss'
    }
    if(!data.type){
      data.type = 'date'
    }

    var options = {
      /*ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },*/
      timePicker24Hour: true,
      autoUpdateInput: false,
      showDropdowns: true,
      locale
    }
    if(typeof data.showDropdowns!="undefined"){
      options.showDropdowns = data.showDropdowns
    }
    let startDate = data.startDate ? data.startDate : ''
    let endDate = data.endDate ? data.endDate : ''

    if(startDate){
      startDate = moment(startDate).format(locale.format)
      options.startDate = startDate
    } else {
      options.startDate = new Date()
    }

    if(endDate){
      endDate = moment(endDate).format(locale.format)
      options.endDate = data.endDate
    } else {
      options.endDate = new Date()
    }
    elementBtnClear.click(function (){
      let dataElement = $(this).siblings('.date-range-picker')
      dataElement.val('');
      $(this).siblings('input[type=hidden]').val('');
      dataElement.data().daterangepicker.firstUpdate = false
      $(this).hide()
    })

    switch (data.type) {
      case 'date':
        options.singleDatePicker = true;
        var name = data.name ? data.name : 'date'
        $(this).after(`<input type="hidden" name="${name}" value="${startDate}">`);
        $(this).val(startDate)
        startDate && $(this).siblings('.date-clear').show()
        break;
      case 'date-range':
        let startName = data.startName ? data.startName : 'startDate'
        let endName = data.endName ? data.endName : 'endDate'
        if(startDate && endDate){
          $(this).val(startDate + ' 至 ' + endDate)
          $(this).siblings('.date-clear').show()
        }
        $(this).after(`<input type="hidden" name="${startName}" value="${startDate}">`);
        $(this).after(`<input type="hidden" name="${endName}" value="${endDate}">`);
        break
    }
    $(this).daterangepicker(options, function (start, end, label) {
      let data = $(this).data();
      let startDate = start.format(data.locale.format)
      let endDate = end.format(data.locale.format)
      switch (data.type) {
        case 'date':
        case 'date-time':
          options.singleDatePicker = true;
          let name = data.name ? data.name : 'date';
          $(this).siblings(`input[name=${name}]`).val(startDate);
          $(this).val(startDate);
          break;
        case 'date-range':
        case 'date-range-time':
          let startName = data.startName ? data.startName : 'startDate'
          let endName = data.endName ? data.endName : 'endDate'
          $(this).siblings(`input[name=${startName}]`).val(startDate)
          $(this).siblings(`input[name=${endName}]`).val(endDate)
          $(this).val(startDate + data.locale.separator + endDate);
          break
      }
      $(this).change()
      $(this).siblings('.date-clear').show()
    }.bind(this))
  })
}

export default dateTimePickerInit
